import { Link } from 'react-router-dom';
import { ROUTES } from '@traction/shared';

export function TermsPage() {
  return (
    <div className="py-12 bg-cacao-dark">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-xl font-semibold text-[#F5F5F5]">Terms of Service</h1>
        <p className="mt-1.5 text-xs text-cacao-text-tertiary">Last updated: March 2, 2026</p>

        <div className="mt-8 space-y-6 text-sm text-cacao-muted leading-relaxed">
          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">1. Acceptance of Terms</h2>
            <p className="mt-2">
              By accessing or using Traction Bee ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">2. Description of Service</h2>
            <p className="mt-2">
              Traction Bee is an AI-powered growth platform that provides lead generation, email drafting, and outreach management services for business professionals.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">3. User Accounts</h2>
            <p className="mt-2">
              You must create an account to use the Service. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">4. Acceptable Use</h2>
            <p className="mt-2">You agree not to:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Use the Service for any unlawful purpose</li>
              <li>Send spam, unsolicited communications, or violate CAN-SPAM or similar regulations</li>
              <li>Misrepresent your identity or affiliation</li>
              <li>Interfere with the proper operation of the Service</li>
              <li>Attempt to gain unauthorized access to the Service or its systems</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">5. Payment and Billing</h2>
            <p className="mt-2">
              Paid subscriptions are billed monthly or annually in advance. You may cancel at any time, and your subscription will remain active until the end of the current billing period.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">6. Intellectual Property</h2>
            <p className="mt-2">
              The Service, including its design, code, and content, is owned by Traction Bee and protected by intellectual property laws. You retain ownership of any content you create using the Service.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">7. Data and Privacy</h2>
            <p className="mt-2">
              Your use of the Service is also governed by our <Link to={ROUTES.PRIVACY} className="text-cacao-gold hover:text-cacao-gold-hover transition-colors">Privacy Policy</Link>. By using the Service, you consent to our collection and use of data as described therein.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">8. Disclaimer of Warranties</h2>
            <p className="mt-2 uppercase text-xs">
              THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT GUARANTEE THAT THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">9. Limitation of Liability</h2>
            <p className="mt-2 uppercase text-xs">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, CACAO SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">10. Changes to Terms</h2>
            <p className="mt-2">
              We may modify these Terms at any time. We will notify you of material changes via email or through the Service. Continued use after changes constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">11. Governing Law</h2>
            <p className="mt-2">
              These Terms shall be governed by the laws of the State of California, without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">12. Contact</h2>
            <p className="mt-2">
              For questions about these Terms, contact us at{' '}
              <a href="mailto:legal@tractionbee.com" className="text-cacao-gold hover:text-cacao-gold-hover transition-colors">legal@tractionbee.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
